// angular
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Component, effect, inject, OnDestroy } from '@angular/core';
import { filter, Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
// components
import { ButtonComponent } from '@app/core/components/button/button.component';
import { SectionTabsComponent } from '@app/core/components/section-tabs/section-tabs.component';
import { ConfirmationDialogComponent } from '@app/core/dialogs/confirmation-dialog/confirmation-dialog.component';
// interfaces
import { ISectionTab } from '@app/core/shared/interfaces/section-tab.interface';
// services
import { FavoritesService } from './shared/favorites.service';
import { DialogService } from '@app/core/shared/services/dialog.service';

@Component({
  selector: 'pwj-profile-favorites',
  standalone: true,
  imports: [
    TranslateModule,
    SectionTabsComponent,
    ButtonComponent,
    RouterOutlet,
  ],
  templateUrl: './profile-favorites.component.html',
  styleUrl: './profile-favorites.component.scss',
})
export class ProfileFavoritesComponent implements OnDestroy {
  // favorite tabs
  public tabsItems: ISectionTab[] = [
    { tabTitle: 'products' },
    // { tabTitle: 'blogs' },
    // { tabTitle: 'posts' },
  ];
  public currentTab: string = this.tabsItems?.[0]?.tabTitle;
  public favoriteProductsCount: number = 0;

  // dependencies
  private readonly _router = inject(Router);
  private readonly _favoritesService = inject(FavoritesService);
  private readonly _dialogService = inject(DialogService);
  private readonly _navSub: Subscription;

  constructor() {
    this.syncTabFromUrl(this._router.url);
    this._navSub = this._router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this.syncTabFromUrl(this._router.url));

    // set favorite products count
    effect(() => {
      this.favoriteProductsCount =
        this._favoritesService.allFAvoritesProductsCount() || 0;
    });
  }

  ngOnDestroy(): void {
    this._navSub.unsubscribe();
  }

  private syncTabFromUrl(url: string): void {
    const match = url.match(/\/profile\/favorites\/([^/?#]+)/);
    const segment = match?.[1];
    if (segment && this.tabsItems.some(t => t.tabTitle === segment)) {
      this.currentTab = segment;
    }
  }

  public onTabChange(selectedTab: string) {
    this.navigateToOtherRoute(selectedTab);
  }

  public navigateToOtherRoute(tab: string) {
    this._router.navigate([`profile/favorites/${tab}`]);
  }

  public removeAllFavorites() {
    // confirmation dialog to delete all favorites
    const dialogRef = this._dialogService.open(ConfirmationDialogComponent, {
      width: '26em',
      height: '8.5em',
      data: { title: 'profile.favorites.confirmDeleteAllFavorites' },
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        switch (this.currentTab) {
          case 'products':
            {
              this._favoritesService.removeAllProducts();
            }
            break;
          case 'blogs':
            {
            }
            break;
          case 'posts':
            {
            }
            break;
        }
      }
    });
  }
}
